<template>
  <blank-view :bodyStyle="{padding:'6px'}" ref="wrapper">
    <div slot="action">
      <a-button style="margin-right:10px"
                @click="openModal()">{{$t("page_terminal_choose")}}</a-button>
    </div>
    <div v-if="selectGateway" class="vnc-client vnc-container" ref="vncclient"></div>
    <a-modal v-model="visible" :title="$t('page_terminal_choose')" @ok="changeGateway">
      <div style="display:flex;justify-content:center;align-items:center;margin-bottom:20px">
        <span style="margin-right:8px">{{$t("page_tenant_list")}}:</span>
        <app-select placeholder="请选择租户" :list="tenants" v-model="selectTenant"
                    :show-search="true" @changeSelect="getData"
                    style="width:300px;"/>
      </div>
      <div style="display:flex;justify-content:center;align-items:center">
        <span style="margin-right:8px">{{$t("page_terminal_gateways")}}:</span>
        <a-select :showSearch="true" style="width:300px" v-model="selectValue">
          <a-select-option
              v-for="(item,index) in gateways"
              :key="index"
              :value="item.sn"
          >{{item.sn}}</a-select-option>
        </a-select>
      </div>
    </a-modal>
  </blank-view>
</template>

<script>
import { ConsoleGatewayServiceProxy } from "@/service-proxies/app-v2/console.service-proxies";
import { MasterlinkTenantServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import {
  GatewayServiceProxy ,
} from '@/service-proxies/app-v2/iot-console.service-proxies'

const systemService = new MasterlinkTenantServiceProxy();
const service = new ConsoleGatewayServiceProxy();
const igsp = new GatewayServiceProxy();
const BASE_URL = window.TERMINAL_URL;

export default {
  data() {
    return {
      visible: false,
      selectGateway: undefined,
      selectValue: undefined,
      selectTenant: undefined,
      gateways: [],
      tenants: [],
      vncClient: undefined
    };
  },
  mounted() {
    this.getTenants();
    /*this.vncClient= new window.vnc.ui.clientui(this.$refs.vncclient);
    this.vncClient.start();*/
  },
  destroyed() {
    if(this.vncClient){
      this.vncClient.dispose();
    }
  },
  methods: {
    openModal() {
      this.selectValue = this.selectGateway;
      this.visible = true;
    },
    changeGateway() {
      this.selectGateway = this.selectValue;
      this.visible = false;

      this.$nextTick(() => {
        this.initDesktop();
      });
    },
    initDesktop(){
      if(this.vncClient){
        this.vncClient.dispose();
        this.vncClient= undefined;
      }

      let url = '';
      if(window.masterlink && window.masterlink.webSocketBaseUrl) {
        url = masterlink.webSocketBaseUrl;
      } else {
        const location =  (window.location);
        const wssProtocol = location.protocol==='https:'?'wss://':'ws://';
        const hostArray = location.host.split('.');
        console.log(hostArray);
        if(hostArray.length>2){
          hostArray[0]='www';
        }else{
          hostArray.unshift('www');
        }
        const wwwHost = hostArray.join('.');
        url = `${wssProtocol}${wwwHost}`;

      }

      const uri = new URL(url);
      const opt= {
        username: 'android',
        server: uri.hostname,
        proxy: true,
        hostId: this.selectGateway,
        protocol: uri.protocol==='wss:'?'wss':'ws',
        port: uri.port||(uri.protocol==='wss:'?443:80),
        servicePath:'/ws-vncproxy',
      };
      console.log(opt);

      this.vncClient= new window.vnc.ui.clientui(this.$refs.vncclient, opt);
      this.vncClient.start();

    },
    async getData() {
      console.log('getData');
      let path = this.$route.path
      if(~path.indexOf('iot-console')) {
        let params = {
          current: 1,
          filter: '',
          size: -1,
          tenantId: this.selectTenant,
          isOnline: undefined,
          batchCode: undefined,
          ascs: undefined,
          descs: undefined
        }
        let { items } = await igsp.findGatewayList(params)
        this.gateways = items.map((item) => ({
          sn: item.code,
        }));
      } else {
        const { records } = await service.queryGatewayList(1, false, undefined, -1, this.selectTenant);
        this.gateways = records.map((item) => ({
          sn: item.sn,
        }));
      }
    },
    async getTenants() {
      const {
        data: { records },
      } = await systemService.getTenants(undefined, 1, -1, undefined, undefined);
      this.tenants = records.map(item => ({ label: item.tenantName, value: item.tenantId }))
    },
  },
};

</script>

<style scoped lang="less">
.pad-desktop{
  width: 100%;
  height: 100%;
}

.vnc-client{
  width: 100%;
  height: 100%;
}
</style>
